import type { CitiesTranslation } from './types'

/**
 * Urdu translations for Cities domain
 */
export const citiesTranslationUr: CitiesTranslation = {
  // Page/Section level
  title: 'شہر',
  subtitle: 'جغرافیائی علاقوں میں شہروں کا انتظام کریں',

  // Actions
  addCity: 'شہر شامل کریں',
  editCity: 'شہر میں ترمیم کریں',
  deleteCity: 'شہر حذف کریں',

  // Drawer Headers
  addCityDescription: 'نیا شہر بنانے کے لیے تفصیلات بھریں',
  editCityDescription: 'نیچے شہر کی تفصیلات اپ ڈیٹ کریں',
  viewCityDescription: 'شہر کی معلومات دیکھیں',

  // Search and states
  searchPlaceholder: 'شہر تلاش کریں...',
  noCities: 'کوئی شہر نہیں ملا',
  noCitiesDescription:
    'ابھی تک کوئی شہر ترتیب نہیں دیا گیا۔ مقامات کا انتظام شروع کرنے کے لیے اپنا پہلا شہر شامل کریں۔',
  addFirst: 'اپنا پہلا شہر شامل کریں',

  // Form fields
  code: 'شہر کا کوڈ',
  codePlaceholder: 'مثال: RYD, JED',
  name: 'شہر کا نام (انگریزی)',
  namePlaceholder: 'مثال: Riyadh',
  nameArabic: 'شہر کا نام (عربی)',
  nameArabicPlaceholder: 'مثال: الرياض',
  stateProvince: 'صوبہ/ریاست (انگریزی)',
  stateProvincePlaceholder: 'مثال: Riyadh Province',
  stateProvinceArabic: 'صوبہ/ریاست (عربی)',
  stateProvinceArabicPlaceholder: 'مثال: منطقة الرياض',
  salesDistrict: 'SAP سیلز ڈسٹرکٹ',
  salesDistrictPlaceholder: 'مثال: 0001',
  basicInformation: 'بنیادی معلومات',
  arabicOptional: 'عربی (اختیاری)',
  region: 'علاقہ',
  selectRegion: 'علاقہ منتخب کریں',
  country: 'ملک',
  selectCountry: 'ملک منتخب کریں',
  status: 'حیثیت',

  // Status values
  active: 'فعال',
  inactive: 'غیر فعال',
  all: 'سب',

  // Stats
  totalCities: 'کل شہر',
  activeCities: 'فعال',
  inactiveCities: 'غیر فعال',

  // Table headers
  table: {
    code: 'کوڈ',
    name: 'نام',
    region: 'علاقہ',
    country: 'ملک',
    stateProvince: 'صوبہ/ریاست',
    salesDistrict: 'سیلز ڈسٹرکٹ',
    status: 'حیثیت',
    actions: 'اعمال',
  },

  // Card content
  card: {
    region: 'علاقہ',
    country: 'ملک',
    noRegion: 'کوئی علاقہ تفویض نہیں',
    noCountry: 'کوئی ملک تفویض نہیں',
  },

  // Messages
  messages: {
    createSuccess: 'شہر بنایا گیا',
    createSuccessDescription: 'نیا شہر کامیابی سے بنایا گیا۔',
    updateSuccess: 'شہر اپ ڈیٹ ہوا',
    updateSuccessDescription: 'شہر کامیابی سے اپ ڈیٹ ہو گیا۔',
    deleteSuccess: 'شہر حذف ہوا',
    deleteSuccessDescription: 'شہر ہٹا دیا گیا۔',
    deleteConfirm: 'شہر حذف کریں',
    deleteConfirmDescription:
      'کیا آپ واقعی اس شہر کو حذف کرنا چاہتے ہیں؟ اس سے پتوں اور مقامات پر اثر پڑ سکتا ہے۔',
    loadError: 'شہر لوڈ کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔',
  },

  // Validation
  validation: {
    codeRequired: 'شہر کا کوڈ درکار ہے',
    codeInvalid: 'شہر کا کوڈ حروف و اعداد اور بڑے حروف میں ہونا چاہیے',
    nameRequired: 'شہر کا نام درکار ہے',
    regionRequired: 'علاقہ درکار ہے',
  },

  // Filter
  filter: {
    all: 'تمام حیثیت',
    active: 'صرف فعال',
    inactive: 'صرف غیر فعال',
    byRegion: 'علاقے کے لحاظ سے فلٹر',
    allRegions: 'تمام علاقے',
  },
}
